import React from "react";
import { Link, useInRouterContext } from "react-router-dom";

export const BIRTHDAY_INBOX_PATH = "/organizer/canchas/cumpleanos";

/** Link a la bandeja de cumpleaños (opcionalmente con una solicitud preseleccionada). Sin Router cae a un <a>. */
export default function BirthdayInboxLink({ requestId, children, ...rest }) {
	const inRouter = useInRouterContext();
	const to = requestId
		? `${BIRTHDAY_INBOX_PATH}?solicitud=${encodeURIComponent(requestId)}`
		: BIRTHDAY_INBOX_PATH;
	return inRouter ? (
		<Link to={to} {...rest}>
			{children}
		</Link>
	) : (
		<a href={to} {...rest}>
			{children}
		</a>
	);
}
